<template>
  <section slot="main" class="interact-letter-form-index-container">
    <base-header
      v-bind="letterHeaders"
      @handleNewFrom="handleHeaderNewFrom"
      @handleDelete="handleHeaderDelete"
    />

    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleEdit="handleEdit"
      v-on:handleCopy="handleTableCopy"
      v-on:handleDelete="handleTableDelete"
      v-on:handleSelectionChange="handleLetterSelect"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
    <template #title="scope">
      <div class="jee-color title-box">
        <!-- <div @click="toLinkAddress(scope.scope.row)" v-if="scope.scope.row.viewStatus===1||scope.scope.row.viewStatus===2">
          <jee-icon iconClass="lianjiexingyinyong"></jee-icon>
        </div> -->
        <p class="smart-title" @click="editForm(scope.scope.row)">{{scope.scope.row.title}}</p>
      </div>
    </template>
    </base-table>
    <form-dialog
      ref="addForm"
      v-bind="formEdit"
      :rules="rules"
      v-on:handleConfirm="handleConfirmForm"
      class="smart-add-from"
    ></form-dialog>
    <form-dialog
      ref="copyForm"
      v-bind="formCopy"
      :rules="rules"
      v-on:handleConfirm="handleConfirmCopyForm"
    ></form-dialog>
  </section>
</template>

<script>
import formDialog from '@/components/mixins/formDialog'
import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import baseTable from '@/components/mixins/baseTable'
const columns = [
  {
    prop: 'id',
    label: 'ID',
    minWidth: '80px',
    fixed: 'left',
  },
  {
    prop: 'title',
    label: '标题',
    minWidth: '165px',
    fixed: 'left',
    scopeType: 'slot'
  },
  {
    prop: 'description',
    label: '描述',
    minWidth: '145px'
  },
  {
    prop: 'createUser',
    label: '创建人',
    minWidth: '100px'
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: '180px'
  }
]
export default {
  name: 'interactLetterFormIndex',
  mixins: [formDialog, baseHeader, searchHeader, baseTable],
  components: {},
  data () {
    return {
      formEdit: {
        loading: false,
        title: '新建',
        form: {
          title: '',
          description: ''
        },
        formItems: [
          {
            prop: 'title',
            label: '表单名称',
            maxlength: 15
          },
          {
            prop: 'description',
            label: '表单描述',
            type: 'textarea',
            autosize: { minRows: 3 },
            maxlength: 150
          }
        ],
        buttons: [
          {
            text: '保存并编辑字段',
            type: 'Submit',
            href: '/system/organize/permission'
          },
          {
            text: '保存',
            type: 'Submit'
          }
        ]
      },
      formCopy: {
        loading: false,
        title: '复制表单',
        form: {
          title: '',
          id: ''
        },
        formItems: [
          {
            prop: 'title',
            label: '新表单标题',
            maxlength: 15
          }
        ],
        buttons: [
          {
            text: '确定',
            type: 'Submit'
          }
        ]
      },
      letterHeaders: {
        showAlertIcon: false,
        buttons: [
          {
            type: 'NewFrom',
            text: '新建',
            icon: 'xinjian',
            disabled: !this._checkPermission('/letterForm', 'POST')
          },
          {
            type: 'Delete',
            text: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/letterForm', 'DELETE')
          }
        ]
      },
      searchHeader: {
        searchItems: [
          {
            type: 'searchInput',
            value: 'name',
            placeholder: '按标题搜索',
            style: {
              width: '330px'
            }
          }
        ]
      },
      list: {
        params: {
          typeId: '',
          status: '',
          name: ''
        },
        columns,
        api: 'fetchLetterFormPage',
        handleColumn: [
          {
            type: 'Edit',
            name: '编辑字段',
            icon: 'bianji',
            disabled: !this._checkPermission('/smartForm/updateFields', 'POST')
          },
          {
            type: 'Copy',
            name: '复制',
            icon: 'fuzhi',
            disabled: !this._checkPermission('/smartForm/copy', 'POST')
          },
          {
            type: 'Delete',
            name: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/letterForm', 'DELETE')
          },
        ],
        handleColumnProp: {
          label: '操作',
          width: '235',
          fixed: 'right'
        }
      },
    }
  },
  computed: {
    rules () {
      return {
        title: [
          this.$rules.required(),
          {
            validator: (rule, value, callback) => {
              if (value) {
                var params = {
                  title: value,
                  id: this.formEdit.form.id || ''
                }
                this.$request.fetchLetterFormUnique(params).then(res => {
                  if (res.code === 200) {
                    if (res.data) {
                      callback()
                    } else {
                      callback(new Error('表单名称不能重复'))
                    }
                  } else {
                    callback()
                  }
                })
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // 表格多选操作
    handleLetterSelect (data) {
      var ids = data.map(v => v[this.list.rowKey || 'id'])
      this.list.selectedKeys = ids
    },
    // 新建表单
    handleHeaderNewFrom () {
      this.formEdit.title = '新建'
      this.formEdit.form = {
        title: '',
        description: ''
      }
      this.$refs.addForm.showDialog()
    },
    // 确认新表单
    handleConfirmForm (data, btn) {
      console.log(data)
      this.formEdit.loading = true
      let typeId = ''
      let params = {
        typeId: typeId,
        ...data
      }
      if (data.id) {
        console.log('这里')
        this.$request.fetchLetterFormPut(params).then(res => {
          if (res.code === 200) {
            if (btn.href) {
              this.fetchTableApi()
              this.$routerLink('/interact/letter/form/detail', 'link', { id: res.data, state: 0 })
            } else {
              this.fetchTableApi()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            }
          }
          this.formEdit.loading = false
        }).catch(() => {
          this.formEdit.loading = false
        })
      } else {
        console.log('再这里')
        this.$request.fetchLetterFormAdd(params).then(res => {
          console.log(res.data)
          if (res.code === 200) {
            if (btn.href) {
              this.fetchTableApi()
              this.$routerLink('/interact/letter/form/detail', 'link', { id: res.data, state: 0 })
            } else {
              this.fetchTableApi()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            }
          }
          this.formEdit.loading = false
        }).catch(() => {
          this.formEdit.loading = false
        })
      }
    },
    // 复制表单
    handleConfirmCopyForm (data, btn) {
      this.formCopy.loading = true
      this.$request.fetchLetterFormCopy(data).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }
        this.formCopy.loading = false
      }).catch(() => {
        this.formCopy.loading = false
      })
    },
    // 编辑表单
    editForm (data) {
      this.formEdit.title = '编辑'
      this.formEdit.form = Object.assign(this.formEdit.form, data)
      this.$refs.addForm.showDialog()
    },
    // 头部删除
    handleHeaderDelete () {
      if (this.list.selectedKeys.length > 0) {
        this.$confirm('删除表单连同表单中的数据一起删除，是否确定删除表单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = this.list.selectedKeys
          this.fetchLetterFormDelete(ids)
        })
      } else {
        this.$message('请选择需要操作的数据')
      }
    },
    // 列表搜索
    handleSearchs () {
      this.fetchTableApi()
    },
    // 表格数据
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content.map(d => {
          // if (d.viewStatus === 0) {
          //   d.hiddenStop = true
          // } else if (d.viewStatus === 1 || d.viewStatus === 2) {
          //   d.hiddenIssue = true
          // }
          // if (d.joinCount === 0) {
          //   d.disabledDerive = true
          //   d.disabledEmpty = true
          // }

          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    },
    // 图标链接跳转
    toLinkAddress (row) {
      this.$routerLink('/interact/letter/form/detail', 'Edit', { link: 'linkAddress', state: row.viewStatus, id: row.id })
    },
    // 标题跳转
    toEdit (row) {
      if (row.viewStatus === 1 || row.viewStatus === 2) {
        this.$confirm('此表单处于进行中状态，编辑表单时表单会暂停发布，将导致正在填写此表单的用户无法提交而必须重新填写，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {}
          data.ids = [row.id]
          data.publish = false
          this.fetchSmartFormPublishPut(data)
          this.$routerLink('/interact/letter/form/detail', 'link', { id: row.id, state: 0 })
        }).catch(() => {})
      } else {
        this.$routerLink('/interact/letter/form/detail', 'link', { id: row.id, state: row.viewStatus })
      }
    },
    // 表格跳统计
    // gotoStatistics (row) {
    //   this.$routerLink('/interact/letter/form/detail', 'link', { link: 'statistical', id: row.id, state: row.viewStatus })
    // },
    // 表格编辑
    handleEdit (data) {
      this.toEdit(data)
    },
    // 表格复制
    handleTableCopy (row) {
      this.formCopy.form.id = row.id
      this.$refs.copyForm.showDialog()
    },
    // 表格删除
    handleTableDelete (row) {
      this.$confirm('删除表单连同表单中的数据一起删除，是否确定删除表单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [row.id]
        this.fetchLetterFormDelete(ids)
      })
    },
    // 表单删除
    fetchLetterFormDelete (ids) {
      this.$request.fetchLetterFormDelete({ ids }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchTableApi()
        }
      })
    },
  },
  mounted () {
    // this.$nextTick(() => {
    //   this.fetchsmartFormTypeList()
    // })
  },
  activated () {
    this.fetchTableApi()
  }
}
</script>

<style lang="scss">
  .interact-forbid-index-container{
    
  }
</style>
